/** Compatibility export; the business domain owns this implementation. */
export { IDataDisplate, IDataGlobal, IDataMba, IPodUpload, IPodUploads, TypeUploadData } from '@domains/upload/shared';
